import { AnalyticsStore } from 'bernie-plugin-mobx';
import { inject } from 'mobx-react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import * as React from 'react';

import { useLocalization } from '@shared-ui/localization-context';

import { SearchResultsStore } from 'stores/search-results-store';

import { UitkEmptyState, UitkEmptyStateActionArea } from 'uitk-react-empty-state';
import { UitkHeading } from 'uitk-react-text';
import { UitkIcon } from 'uitk-react-icons';
import { UitkSpacing } from 'uitk-react-spacing';
import { UitkTertiaryButton } from 'uitk-react-button';

import { handleRetry } from 'utils/error-handling-utils';

import { PackageError } from '../multi-item/package-error';

interface SearchErrorMessageProps extends RouteComponentProps {
  analytics?: AnalyticsStore;
  searchResults?: SearchResultsStore;
}

const SearchErrorMessage: React.FC<SearchErrorMessageProps> = inject(
  'searchResults',
  'analytics'
)(({ history, searchResults, analytics, location }) => {
  const { formatText } = useLocalization();

  const { isError, isEmpty, searchCriteria } = searchResults;
  const { misId } = searchCriteria || {};
  if (!isError && !isEmpty) {
    return null;
  }

  if (misId) {
    return (
      <UitkSpacing padding={{ blockstart: 'six', blockend: 'twelve' }}>
        <div className="uitk-type-center">
          <PackageError searchResults={searchResults} analytics={analytics} />
        </div>
      </UitkSpacing>
    );
  }
  const errorMessage =
    !isError && isEmpty ? formatText('hotels.searchResults.emptyResults.text') : formatText('hotels.searchResults.error.text');
  const errorCta = isError ? formatText('hotels.searchResults.error.cta') : '';

  return (
    <UitkSpacing padding={{ blockend: 'twelve' }}>
      <div className="uitk-type-center" data-stid="empty-state-error">
        <UitkSpacing padding={{ blockstart: 'three' }}>
          <UitkEmptyState data-stid={'retry-search'}>
            <UitkIcon name={'error'} />
            <UitkHeading tag="h2">{errorMessage}</UitkHeading>
            <UitkEmptyStateActionArea>
              <UitkTertiaryButton
                name="textonly"
                onClick={() => handleRetry(':errorOnSearch', 'Try Again on error', analytics, searchResults, history, location)}
                type="button"
              >
                {errorCta}
              </UitkTertiaryButton>
            </UitkEmptyStateActionArea>
          </UitkEmptyState>
        </UitkSpacing>
      </div>
    </UitkSpacing>
  );
});

export const SearchErrorMessageWrapper = withRouter(SearchErrorMessage);
